/*! project-name v0.0.1 | (c) 2026 YOUR NAME | MIT License | http://link-to-your-git-repo.com */

import $ from 'jquery';

$(() => {
  const forms = [
    {
      form: '#updates-form',
      input: '#address1',
      city: '#city',
      state: '#state',
      zip: '#zip',
      dropdown: '#state-dropdown',
      latitude: '#latitude',
      longitude: '#longitude'
    },
    {
      form: '#contact-form',
      input: '#field-address-one',
      city: '#field-city',
      state: '#field-state',
      zip: '#field-zipcode',
      dropdown: null,
      latitude: '#field-latitude',
      longitude: '#field-longitude'
    },
    {
      form: '#updates-form-hcp',
      input: '#facility-address-1-hcp',
      city: '#facility-city-hcp',
      state: '#facility-state-hcp',
      zip: '#facility-zip-hcp',
      dropdown: '#state-dropdown',
      latitude: '#facility-latitude-hcp',
      longitude: '#facility-longitude-hcp'
    }
  ];

  forms.forEach((formConfig) => {
    const form = $(formConfig.form);

    if (!form.length) {
      return;
    }

    const menu = form.find('.us-autocomplete-pro-menu');
    const input = form.find(formConfig.input);
    form.find(formConfig.zip).attr('maxlength', '5');     // max length for zip field for all 3 forms

    function buildMenu(suggestions) {
      menu.empty();

      suggestions.forEach((suggestion) => {
        const addressData =
          suggestion.street_line +
          (suggestion.secondary ? ' ' + suggestion.secondary : '') +
          ';' +
          suggestion.city +
          ';' +
          suggestion.state +
          ';' +
          suggestion.zipcode;

        const item = `
          <li class="autocomplete-item">
            <div data-address="${addressData}">
              ${buildAddress(suggestion)}
            </div>
          </li>
        `;

        menu.append(item);
      });

      menu.show();
    }

    // function getSuggestions(search, selected) {
    // $.ajax({
    //   type: 'POST',
    //   url: '/api/smarty.php',
    //   data: {
    //     search: search,
    //     selected: selected || ''
    //   },
    //   dataType: 'json',

    //   success(data) {
    //     if (data.suggestions && data.suggestions.length) {
    //       buildMenu(data.suggestions);
    //     } else {
    //       noSuggestions();
    //     }
    //   },

    //   error(error) {
    //     console.error('Smarty autocomplete error:', error);
    //   }
    // });
    // }

    function getSuggestions(search, selected) {
      $.ajax({
        type: 'POST',
        url: '/api/smarty.php',

        data: {
          search: search,
          selected: selected || ''
        },

        dataType: 'json',

        success(data) {
          if (data.suggestions && data.suggestions.length) {
            buildMenu(data.suggestions);
          } else {
            noSuggestions();
          }
        },

        error(error) {
          console.error('Smarty autocomplete error:', error);
        }
      });
    }

    function getAddressCoordinates(address) {
      $.ajax({
        type: 'POST',
        url: '/api/smarty.php',
        data: {
          street: address.street,
          city: address.city,
          state: address.state,
          zipcode: address.zipcode
        },
        dataType: 'json',

        success(data) {
          if (data.latitude != null && data.longitude != null) {
            form.find(formConfig.latitude)
              .val(data.latitude)
              .trigger('change');

            form.find(formConfig.longitude)
              .val(data.longitude)
              .trigger('change');
          }
        },

        error(error) {
          console.error('Smarty geocoding error:', error);
        }
      });
    }

    // function getSingleAddressData(address) {
    //   $.ajax({
    //     url: 'https://us-street.api.smartystreets.com/street-address?',

    //     data: {
    //       'auth-id': '8d8a3163-ca67-9764-edd6-e1636f2471de',
    //       'auth-token': 'd5DJMo10LqSy7bjE7OIf',
    //       street: address[0],
    //       city: address[1],
    //       state: address[2]
    //     },

    //     dataType: 'json',

    //     success(data) {
    //       if (!data || !data.length) {
    //         return;
    //       }

    //       if (form.find(formConfig.zip).length) {
    //         form.find(formConfig.zip).val(data[0].components.zipcode);
    //       }

    //       if (form.find('#data-lat').length) {
    //         form.find('#data-lat').text(data[0].metadata.latitude);
    //       }

    //       if (form.find('#data-lon').length) {
    //         form.find('#data-lon').text(data[0].metadata.longitude);
    //       }

    //       if (form.find('#data-county').length) {
    //         form.find('#data-county').text(data[0].metadata.county_name);
    //       }

    //       if (form.find('#data-time-zone').length) {
    //         form.find('#data-time-zone').text(data[0].metadata.time_zone);
    //       }
    //     },

    //     error(error) {
    //       console.error('Smarty address data error:', error);
    //     }
    //   });
    // }

    function clearAddressData() {
      form.find(formConfig.city).val('');
      form.find(formConfig.state).val('');
      form.find(formConfig.zip).val('');

      form.find(formConfig.city).removeClass('pointer-events-none bg-[#eee!important]');
      form.find(formConfig.state).removeClass('pointer-events-none bg-[#eee!important]');
      form.find(formConfig.zip).removeClass('pointer-events-none bg-[#eee!important]');
      form.find(formConfig.state).parent().removeClass('cursor-not-allowed');
      form.find(formConfig.zip).parent().removeClass('cursor-not-allowed');

      form.find(formConfig.latitude).val('');
      form.find(formConfig.longitude).val('');

      if (formConfig.dropdown) {
        const stateSelect = form.find(formConfig.dropdown).closest('.custom-select');
        stateSelect.find('.select-trigger').removeClass('pointer-events-none bg-[#eee!important]');
        stateSelect.removeClass('cursor-not-allowed');
        form.find(formConfig.dropdown)
          .closest('.custom-select')
          .find('.selected-value')
          .text('Choose State');
      }

      form.find('#data-lat').empty();
      form.find('#data-lon').empty();
      form.find('#data-county').empty();
      form.find('#data-time-zone').empty();
    }

    function noSuggestions() {
      menu.empty();

      menu.append(`
        <li class="autocomplete-no-results">
          <div>No Suggestions Found</div>
        </li>
      `);

      menu.show();
    }

    function buildAddress(suggestion) {
      let whiteSpace = '';

      if (suggestion.secondary || suggestion.entries > 1) {
        if (suggestion.entries > 1) {
          suggestion.secondary = (suggestion.secondary || '') + ' (' + suggestion.entries + ' more entries)';
        }

        whiteSpace = ' ';
      }

      const address =
        suggestion.street_line +
        whiteSpace +
        (suggestion.secondary || '') +
        ' ' +
        suggestion.city +
        ', ' +
        suggestion.state +
        ' ' +
        suggestion.zipcode;

      const inputAddress = input.val();

      for (let i = 0; i < address.length; i++) {
        const theLettersMatch = typeof inputAddress[i] === 'undefined' || address[i].toLowerCase() !== inputAddress[i].toLowerCase();

        if (theLettersMatch) {
          return [address.slice(0, i), '<b>', address.slice(i), '</b>'].join('');
        }
      }

      return address;
    }

    function updateStateDropdown(stateValue) {
      const state = stateValue.trim().toUpperCase();
      const stateInput = form.find(formConfig.state);
      if (!formConfig.dropdown) {
        stateInput
          .val(state)
          .trigger('input')
          .trigger('change')
          .trigger('blur');
        return;
      }

      const stateDropdown = form.find(formConfig.dropdown);
      const stateOption = stateDropdown
        .find('li[role="option"]')
        .filter(function () {
          return $(this).attr('data-value').toUpperCase() === state;
        });

      if (stateOption.length) {
        const initials = stateOption.data('value').trim(); // Capture data value instead of text
        const fullStateName = stateOption.text().trim();
        stateInput
          .val(initials)
          .trigger('input')
          .trigger('change')
          .trigger('blur');

        stateDropdown.find('li').removeClass('selected');
        stateOption.addClass('selected');

        stateOption
          .closest('.custom-select')
          .find('.selected-value')
          .text(fullStateName);
      } else {
        stateInput
          .val(state)
          .trigger('input')
          .trigger('change')
          .trigger('blur');
      }
    }

    menu.on('click', 'li.autocomplete-item', function () {
      const selectedItem = this;
      const text = selectedItem.innerText;

      const addressElement = selectedItem.querySelector('[data-address]');

      if (!addressElement) {
        return;
      }

      const address = addressElement.dataset.address.split(';');

      const searchForMoreEntriesText = /(?:\ more\ entries\))/;

      const addressApiVal = address[0];
      const cityApiVal = address[1];
      const stateApiVal = address[2];
      const zipApiVal = address[3];

      if (text.search(searchForMoreEntriesText) !== -1) {
        input.val(addressApiVal + ' ');

        let selected = text.replace(' more entries', '');
        selected = selected.replace(',', '');

        getSuggestions(addressApiVal, selected);

        return;
      }

      form.find(formConfig.input)
        .val(addressApiVal)
        .trigger('input')
        .trigger('change')
        .trigger('blur');

      form.find(formConfig.city)
        .val(cityApiVal)
        .trigger('input')
        .trigger('change')
        .trigger('blur');

      form.find(formConfig.city).addClass('pointer-events-none bg-[#eee!important]')
      form.find(formConfig.city).parent().addClass('cursor-not-allowed')

      updateStateDropdown(stateApiVal);
      if (formConfig.dropdown) {
        const stateSelect = form.find(formConfig.dropdown).closest('.custom-select');
        stateSelect.find('.select-trigger').addClass('pointer-events-none bg-[#eee!important]');
        stateSelect.addClass('cursor-not-allowed');
      }

      form.find(formConfig.zip)
        .val(zipApiVal)
        .trigger('input')
        .trigger('change')
        .trigger('blur');
      form.find(formConfig.zip).addClass('pointer-events-none bg-[#eee!important]')
      form.find(formConfig.zip).parent().addClass('cursor-not-allowed')
      getAddressCoordinates({
        street: addressApiVal,
        city: cityApiVal,
        state: stateApiVal,
        zipcode: zipApiVal
      });

      if (formConfig.form === '#updates-form' && window.updateFormValidation) {
        // window.updateFormValidation.revalidateField('#address1');
        // window.updateFormValidation.revalidateField('#city');
        // window.updateFormValidation.revalidateField('#state');
        window.updateFormValidation.revalidateField('#zip');
      }

      if (formConfig.form === '#updates-form-hcp' && window.hcpValidation) {
        window.hcpValidation.revalidateField('#facility-address-1-hcp');
        window.hcpValidation.revalidateField('#facility-city-hcp');
        window.hcpValidation.revalidateField('#facility-state-hcp');
        window.hcpValidation.revalidateField('#facility-zip-hcp');
      }
      if (formConfig.form === '#contact-form' && window.contactFormValidation) {
        window.contactFormValidation.revalidateField('#field-address-one');
        window.contactFormValidation.revalidateField('#field-city');
        window.contactFormValidation.revalidateField('#field-state');
        window.contactFormValidation.revalidateField('#field-zipcode');
      }

      if (form.find('.address1-count').length) {
        form.find('.address1-count span').text(addressApiVal.length);
      }

      if (form.find('#city-count').length) {
        form.find('#city-count').text(cityApiVal.length);
      }

      menu.hide();

      // getSingleAddressData([addressApiVal, cityApiVal, stateApiVal, zipApiVal]);
    });

    input.on('keyup', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === 'Escape') {
        return;
      }

      const textInput = input.val();

      if (textInput.length > 3) {
        getSuggestions(textInput);
      } else {
        menu.hide();
        clearAddressData();
      }

      if (form.find('.address1-count').length) {
        form.find('.address1-count span').text(textInput.length);
      }
    });

    if (input.length) {
      menu.css('width', input.outerWidth() + 'px');
    }

    form.find(formConfig.city).on('keyup', function () {
      if (form.find('#city-count').length) {
        form.find('#city-count').text($(this).val().length);
      }
    });

    $(document.body).on('click', (event) => {
      if (!$(event.target).closest(`${formConfig.input}, .us-autocomplete-pro-menu`).length) {
        menu.hide();
      }
    });
  });
});
